import React, { useState } from 'react';
import { svgIcons } from '../../../../style/fonts/SvgIcons';
import { Col, Nav, Row, Tab } from "react-bootstrap";
import { Link } from 'react-router-dom';
import AllNotes from './AllNotes';
import NoteSidebar from '../NotesSidebarForm/NotesSidebar';
import ClientNotes from './ClientNotes'
import InternalNotes from './InternalNotes'
const LeadNotes = () => {
    const [activityTogglePopup, setActivityTogglePopup] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const handleAddNotes = () => {
        setActivityTogglePopup(true);
        setIsEditing(false);
    };
    const handleEditNotes = () => {
        setActivityTogglePopup(true);
        setIsEditing(true)
    };

    const closeSidebar = () => {
        setActivityTogglePopup(false);
    };

    return (
        <>
            <NoteSidebar activityTogglePopup={activityTogglePopup} closeSidebar={closeSidebar} isEditing={isEditing} />
            <div className='row'>
                <div className='col-md-12'>
                    <div className='card card-css'>
                        <div className='card-header'>
                            <div className='d-flex justify-content-between'>
                                <h5>Notes</h5>
                                <div className='d-flex gap-2'>
                                    <i className='ti ti-plus' onClick={handleAddNotes} style={{ cursor: "pointer" }}></i>
                                    {svgIcons.sorterIcon}
                                </div>
                            </div>
                        </div>
                        <div className='card-body card-body-padding'>
                            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                                <Row>
                                    <Col sm={12}>
                                        <Nav variant="pills" className="flex">
                                            <Nav.Item>
                                                <Nav.Link eventKey="first">All Notes</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="second">Client Notes</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="third">Internal Notes</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                    </Col>
                                    <Col sm={12} className='mt-3'>
                                        <Tab.Content>
                                            <Tab.Pane eventKey="first">
                                                <div className="icon-form">
                                                    <span className="form-icon">
                                                        <i className="ti ti-search" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search Notes"
                                                    />
                                                </div>
                                                <AllNotes handleEditNotes={handleEditNotes} setIsEditing={setIsEditing} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second">
                                                <div className="icon-form">
                                                    <span className="form-icon">
                                                        <i className="ti ti-search" />
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Search Notes"
                                                    />
                                                </div>
                                                
                                                <ClientNotes handleEditNotes={handleEditNotes} setIsEditing={setIsEditing} />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="third"><InternalNotes/></Tab.Pane>
                                        </Tab.Content>
                                    </Col>
                                </Row>
                            </Tab.Container>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LeadNotes;
